import shop1 from "@/assets/buyukcekmece-isyeri-1.jpg.asset.json";
import shop2 from "@/assets/buyukcekmece-isyeri-2.jpg.asset.json";
import shop3 from "@/assets/buyukcekmece-isyeri-3.jpg.asset.json";
import shop5 from "@/assets/buyukcekmece-isyeri-5.jpg.asset.json";
import shop6 from "@/assets/buyukcekmece-isyeri-6.jpg.asset.json";
import avcilarShop1 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-1.jpg.asset.json";
import avcilarShop2 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-2.jpg.asset.json";
import avcilarShop3 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-3.jpg.asset.json";
import avcilarShop4 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-4.jpg.asset.json";
import avcilarShop5 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-5.jpg.asset.json";
import avcilarShop6 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-6.jpg.asset.json";
import avcilarShop7 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-7.jpg.asset.json";
import avcilarShop8 from "@/assets/avcilar-hizli-elektrikci-7-24-dukkan-8.jpg.asset.json";
import bahcesehirShop1 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-1.jpg.asset.json";
import bahcesehirShop2 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-2.jpg.asset.json";
import bahcesehirShop3 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-3.jpg.asset.json";
import bahcesehirShop4 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-4.jpg.asset.json";
import bahcesehirShop5 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-5.jpg.asset.json";
import bahcesehirShop6 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-6.jpg.asset.json";
import bahcesehirShop7 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-7.jpg.asset.json";
import bahcesehirShop8 from "@/assets/bahcesehir-hizli-elektrikci-7-24-dukkan-8.jpg.asset.json";
import esenyurtShop1 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-1.jpg.asset.json";
import esenyurtShop2 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-2.jpg.asset.json";
import esenyurtShop3 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-3.jpg.asset.json";
import esenyurtShop4 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-4.jpg.asset.json";
import esenyurtShop5 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-5.jpg.asset.json";
import esenyurtShop6 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-6.jpg.asset.json";
import esenyurtShop7 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-7.jpg.asset.json";
import esenyurtShop8 from "@/assets/esenyurt-hizli-elektrikci-7-24-dukkan-8.jpg.asset.json";
import beylikduzuShop1 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-1.jpg.asset.json";
import beylikduzuShop2 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-2.jpg.asset.json";
import beylikduzuShop3 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-3.jpg.asset.json";
import beylikduzuShop4 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-4.jpg.asset.json";
import beylikduzuShop5 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-5.jpg.asset.json";
import beylikduzuShop6 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-6.jpg.asset.json";
import beylikduzuShop7 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-7.jpg.asset.json";
import beylikduzuShop8 from "@/assets/beylikduzu-hizli-elektrikci-7-24-dukkan-8.jpg.asset.json";
import silivriShop1 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-1.jpg.asset.json";
import silivriShop2 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-2.jpg.asset.json";
import silivriShop3 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-3.jpg.asset.json";
import silivriShop4 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-4.jpg.asset.json";
import silivriShop5 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-5.jpg.asset.json";
import silivriShop6 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-6.jpg.asset.json";
import silivriShop7 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-7.jpg.asset.json";
import silivriShop8 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-8.jpg.asset.json";
import silivriShop9 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-9.jpg.asset.json";
import silivriShop10 from "@/assets/silivri-hizli-elektrikci-7-24-dukkan-10.jpg.asset.json";

/** Varlık CDN'i `?w=` parametresiyle yeniden boyutlandırır ve AVIF/WebP pazarlığı yapar. */
export const shopImage = (url: string, width: number) =>
  `${url}${url.includes("?") ? "&" : "?"}w=${width}`;

export const SHOP_IMAGE_WIDTHS = [400, 640, 960, 1280];

/** Cihaz genişliğine göre doğru boyutun indirilmesini sağlayan srcset dizesi. */
export const shopSrcSet = (url: string, widths: number[] = SHOP_IMAGE_WIDTHS) =>
  widths.map((w) => `${shopImage(url, w)} ${w}w`).join(", ");

export interface ShopPhoto {
  url: string;
  width: number;
  height: number;
  /** Fotoğrafın sahnesini anlatan kısa ifade (alt metin ve açıklamada kullanılır) */
  scene: string;
  /** Kart altındaki kısa açıklama şablonu (bölge adı eklenir) */
  caption: (area: string) => string;
}

export interface ShopHeroPhoto {
  url: string;
  width: number;
  height: number;
  scene: string;
}

const defaultHeroPhoto: ShopHeroPhoto = {
  url: shop1.url,
  width: 1280,
  height: 853,
  scene: "cadde üzerindeki tabelalı iş yerimizin ve vitrinimizin gündüz ön cephe görünümü",
};

const defaultPhotos: ShopPhoto[] = [
  {
    url: shop1.url,
    width: 1280,
    height: 853,
    scene: "cadde üzerindeki tabelalı iş yerimizin gündüz görünümü",
    caption: (area) =>
      `${area} bölgesine çıkan ekiplerimizin toplandığı iş yerimiz: gerçek adres, gerçek mağaza.`,
  },
  {
    url: shop2.url,
    width: 1280,
    height: 853,
    scene: "iş yerimizin önden görünümü; pano, kablo ve aydınlatma malzemelerinin sergilendiği vitrin",
    caption: (area) =>
      `Pano, sigorta, kablo ve aydınlatma malzemeleri stokta; ${area} içindeki arızalarda malzeme beklemeden çözüm üretiyoruz.`,
  },
  {
    url: shop3.url,
    width: 1280,
    height: 853,
    scene: "akşam saatlerinde ışıkları açık iş yerimiz ve kapının önünde bekleyen servis aracımız",
    caption: (area) =>
      `Gece de açığız: ${area} içindeki acil elektrik arızalarında servis aracımız 7/24 yola çıkıyor.`,
  },
  {
    url: shop5.url,
    width: 1280,
    height: 853,
    scene: "iş yerimizin köşe cephesi ve çantasıyla servise çıkan ustamız",
    caption: (area) =>
      `Belgeli ustalarımız ${area} adreslerine doğrudan iş yerimizden hareket ediyor; aracı ya da komisyoncu yok.`,
  },
  {
    url: shop6.url,
    width: 1280,
    height: 853,
    scene: "iş yerimizin aydınlatılmış vitrini ve marka tabelası",
    caption: (area) =>
      `Tabelamızı taşıyan gerçek bir iş yeriyiz; ${area} sakinleri işlem öncesi ve sonrası bizi yerinde bulabilir.`,
  },
];

const avcilarHeroPhoto: ShopHeroPhoto = {
  url: avcilarShop1.url,
  width: 1448,
  height: 1086,
  scene: "Marmara Caddesi'ndeki tabelalı iş yerimizin, ürün rafları ve servis tezgâhıyla birlikte görünen ön cephesi",
};

const avcilarPhotos: ShopPhoto[] = [
  {
    url: avcilarShop1.url,
    width: 1448,
    height: 1086,
    scene: "Marmara Caddesi'ndeki tabelalı iş yerimizin geniş açıdan ön cephe görünümü",
    caption: (area) =>
      `${area} bölgesine çıkan ekiplerimizin hazırlandığı gerçek iş yerimiz; tabela, mağaza ve elektrik malzemeleri bir arada.`,
  },
  {
    url: avcilarShop2.url,
    width: 1448,
    height: 1086,
    scene: "iş yerimizin servis tezgâhından ürün raflarına ve girişe doğru iç görünümü",
    caption: (area) =>
      `${area} servislerinde kullandığımız pano, sigorta, kablo ve priz malzemelerini iş yerimizde hazır bulunduruyoruz.`,
  },
  {
    url: avcilarShop3.url,
    width: 1448,
    height: 1086,
    scene: "iş yerimizin servis tezgâhında elektrik projesini birlikte inceleyen ustalarımız",
    caption: (area) =>
      `${area} elektrik işleri için ekibimiz ölçüm, malzeme ve uygulama planını kendi servis tezgâhımızda hazırlıyor.`,
  },
  {
    url: avcilarShop4.url,
    width: 1448,
    height: 1086,
    scene: "Marmara Caddesi üzerindeki aydınlatılmış vitrinimizin ve marka tabelamızın görünümü",
    caption: (area) =>
      `${area} müşterilerinin işlem öncesi ve sonrası bizi bulabileceği, Marmara Caddesi üzerindeki gerçek mağazamız.`,
  },
  {
    url: avcilarShop5.url,
    width: 1086,
    height: 1448,
    scene: "rafından otomatik sigorta seçen üniformalı elektrik ustamız",
    caption: (area) =>
      `${area} arızalarında gereken sigorta ve tesisat malzemesini stoktan seçerek beklemeden servise çıkıyoruz.`,
  },
  {
    url: avcilarShop6.url,
    width: 1312,
    height: 1199,
    scene: "elektrik panoları ve kablo çeşitlerinin sergilendiği mağaza vitrinimiz",
    caption: (area) =>
      `${area} için pano, priz, anahtar, kablo ve aydınlatma çözümlerini mağazamızdaki ürünlerle destekliyoruz.`,
  },
  {
    url: avcilarShop7.url,
    width: 1086,
    height: 1448,
    scene: "akşam saatlerinde açık olan iş yerimizde servis çantasını hazırlayan ustamız",
    caption: (area) =>
      `${area} içindeki gece arızaları için 7/24 açık hattımızla servis çantamızı hazırlayıp yola çıkıyoruz.`,
  },
  {
    url: avcilarShop8.url,
    width: 1448,
    height: 1086,
    scene: "servis tezgâhında müşteriye elektrik malzemesini açıklayan ustamız",
    caption: (area) =>
      `${area} elektrik işlerinde kullanılacak malzemeyi ve yapılacak işlemi başlamadan önce açıkça anlatıyoruz.`,
  },
];

/** İlçe bazlı gerçek iş yeri fotoğrafları. Yeni ilçe fotoğrafları geldikçe burada tanımlanır. */
const bahcesehirHeroPhoto: ShopHeroPhoto = {
  url: bahcesehirShop1.url,
  width: 1672,
  height: 941,
  scene:
    "Atrium Çarşısı No:406'daki tabelalı iş yerimizin, ürün rafları ve servis tezgâhıyla birlikte görünen ön cephesi",
};

const bahcesehirPhotos: ShopPhoto[] = [
  {
    url: bahcesehirShop1.url,
    width: 1672,
    height: 941,
    scene: "Atrium Çarşısı No:406'daki tabelalı iş yerimizin geniş açıdan ön cephe görünümü",
    caption: (area) =>
      `${area} bölgesine çıkan ekiplerimizin hazırlandığı gerçek iş yerimiz: Atrium Çarşısı No:406, tabelalı mağaza ve stoklu elektrik malzemesi.`,
  },
  {
    url: bahcesehirShop2.url,
    width: 1448,
    height: 1086,
    scene: "servis tezgâhımızdan çarşı girişine ve malzeme raflarına bakan iç görünüm",
    caption: (area) =>
      `${area} servislerinde kullandığımız pano, sigorta, priz ve kabloları mağazamızda hazır bulunduruyoruz.`,
  },
  {
    url: bahcesehirShop3.url,
    width: 1448,
    height: 1086,
    scene: "ustalarımızın sigorta ve tesisat projesini birlikte incelediği servis tezgâhımız",
    caption: (area) =>
      `${area} elektrik işlerinde ölçüm, malzeme ve uygulama planını belgeli ustalarımız iş yerimizde birlikte hazırlıyor.`,
  },
  {
    url: bahcesehirShop4.url,
    width: 1370,
    height: 1148,
    scene: "pano, priz ve kablo çeşitlerinin sergilendiği aydınlatmalı mağaza vitrinimiz",
    caption: (area) =>
      `${area} için pano, priz, anahtar, kablo ve aydınlatma çözümlerini vitrinimizdeki ürünlerle destekliyoruz.`,
  },
  {
    url: bahcesehirShop5.url,
    width: 1086,
    height: 1448,
    scene: "raftan otomatik sigorta ve kaçak akım rölesi seçen üniformalı ustamız",
    caption: (area) =>
      `${area} arızalarında gereken sigorta ve kaçak akım rölesini stoktan alıp beklemeden servise çıkıyoruz.`,
  },
  {
    url: bahcesehirShop6.url,
    width: 1448,
    height: 1086,
    scene: "çarşı koridorundan görünen geniş vitrinimiz ve servis çantasını hazırlayan ustamız",
    caption: (area) =>
      `${area} sakinleri bizi Atrium Çarşısı içindeki gerçek adresimizde, işlem öncesi ve sonrası yerinde bulabilir.`,
  },
  {
    url: bahcesehirShop7.url,
    width: 1370,
    height: 1148,
    scene: "tezgâhta müşteriye sigorta ve malzeme seçimini anlatan ustamız",
    caption: (area) =>
      `${area} elektrik işlerinde kullanılacak malzemeyi ve yapılacak işlemi başlamadan önce açıkça anlatıyoruz.`,
  },
  {
    url: bahcesehirShop8.url,
    width: 1448,
    height: 1086,
    scene: "akşam saatlerinde ışıkları açık olan iş yerimiz",
    caption: (area) =>
      `${area} içindeki gece arızaları için 7/24 açığız; mağazamız ve servis ekibimiz her saat ulaşılabilir.`,
  },
];

const esenyurtHeroPhoto: ShopHeroPhoto = {
  url: esenyurtShop7.url,
  width: 1312,
  height: 1199,
  scene: "Mehterçeşme Ufuk Caddesi No:80'deki tabelalı Esenyurt Hızlı Elektrikçi 7/24 iş yerimizin ön cephe görünümü",
};

const esenyurtPhotos: ShopPhoto[] = [
  {
    url: esenyurtShop7.url,
    width: 1312,
    height: 1199,
    scene: "Mehterçeşme Ufuk Caddesi No:80'deki tabelalı iş yerimizin ön cephe ve vitrin görünümü",
    caption: (area) => `${area} elektrikçi ekiplerimizin hareket ettiği gerçek iş yerimiz; 7 numaralı öne çıkan mağaza görünümü.`,
  },
  {
    url: esenyurtShop1.url,
    width: 1672,
    height: 941,
    scene: "Ufuk Caddesi üzerindeki iş yerimizin geniş açıdan gündüz görünümü",
    caption: (area) => `${area} bölgesine çıkan ekiplerimizin hazırlandığı tabelalı iş yerimiz ve stoklu elektrik malzemelerimiz.`,
  },
  {
    url: esenyurtShop2.url,
    width: 1448,
    height: 1086,
    scene: "servis tezgâhında elektrik malzemesini ve iş planını inceleyen ustalarımız",
    caption: (area) => `${area} elektrik işleri için ekiplerimiz malzeme ve uygulama planını servis tezgâhımızda hazırlıyor.`,
  },
  {
    url: esenyurtShop3.url,
    width: 1448,
    height: 1086,
    scene: "köşe konumdaki tabelalı mağazamızın vitrin ve giriş görünümü",
    caption: (area) => `${area} sakinlerinin işlem öncesi ve sonrası bizi bulabileceği Mehterçeşme'deki gerçek mağazamız.`,
  },
  {
    url: esenyurtShop4.url,
    width: 1370,
    height: 1148,
    scene: "servis tezgâhında elektrik panosu ve sigorta hakkında müşterimizi bilgilendiren ustamız",
    caption: (area) => `${area} elektrik işlerinde kullanılacak sigorta, pano malzemesi ve işlemi başlamadan önce açıkça anlatıyoruz.`,
  },
  {
    url: esenyurtShop5.url,
    width: 1348,
    height: 1167,
    scene: "akşam saatlerinde açık ve aydınlatılmış iş yerimizin ön cephe görünümü",
    caption: (area) => `${area} içindeki gece arızaları için 7/24 açık hattımızla iş yerimizden servis yönlendiriyoruz.`,
  },
  {
    url: esenyurtShop6.url,
    width: 1086,
    height: 1448,
    scene: "mağaza rafından otomatik sigorta seçen üniformalı elektrik ustamız",
    caption: (area) => `${area} arızalarında gereken sigorta ve tesisat malzemesini stoktan seçerek beklemeden yola çıkıyoruz.`,
  },
  {
    url: esenyurtShop8.url,
    width: 1448,
    height: 1086,
    scene: "ölçüm cihazları, pano ürünleri ve kablo raflarıyla iş yerimizin iç görünümü",
    caption: (area) => `${area} servislerinde kullandığımız ölçüm cihazlarını, pano ürünlerini ve kabloları mağazamızda hazır bulunduruyoruz.`,
  },
];

/** Beylikdüzü Hızlı Elektrikçi 7/24 iş yerimizin gerçek fotoğrafları. */
const beylikduzuHeroPhoto: ShopHeroPhoto = {
  url: beylikduzuShop1.url,
  width: 1312,
  height: 1199,
  scene:
    "Hasan Aslan Plaza Kat 2 Daire 11'deki tabelalı iş yerimizin açık kapısı ve içeride görünen çalışma tezgâhımız",
};

const beylikduzuPhotos: ShopPhoto[] = [
  {
    url: beylikduzuShop1.url,
    width: 1312,
    height: 1199,
    scene: "tabelalı giriş kapımız, iletişim panomuz ve içerideki çalışma tezgâhımız",
    caption: (area) =>
      `${area} ekiplerimizin hareket noktası: Hasan Aslan Plaza Kat 2 Daire 11'deki gerçek iş yerimiz.`,
  },
  {
    url: beylikduzuShop2.url,
    width: 1086,
    height: 1448,
    scene: "karşılama bankosu önünde çanta hazırlayan iki üniformalı ustamız",
    caption: (area) =>
      `${area} çağrısı geldiğinde ustalarımız çantasını burada hazırlayıp doğrudan adrese çıkıyor.`,
  },
  {
    url: beylikduzuShop3.url,
    width: 1448,
    height: 1086,
    scene: "sigorta, pano ve kablo raflarının önünde iş kaydı tutan ustabaşımız",
    caption: (area) =>
      `Her ${area} işi kayıt altına alınıyor; kullanılan sigorta, kablo ve pano malzemesi faturada tek tek yazıyor.`,
  },
  {
    url: beylikduzuShop4.url,
    width: 1312,
    height: 1199,
    scene: "müşterisine otomatik sigorta seçeneklerini anlatan teknik danışmanımız",
    caption: (area) =>
      `${area} içindeki işlerde hangi sigortanın neden seçildiğini işe başlamadan önce anlatıyoruz.`,
  },
  {
    url: beylikduzuShop5.url,
    width: 1312,
    height: 1199,
    scene: "atölyemizde test panosu üzerinde ölçüm yapan ustamız ve malzeme rafları",
    caption: (area) =>
      `${area} montajlarında kullanılan panolar atölyemizde kurulup ölçülerek sahaya çıkıyor.`,
  },
  {
    url: beylikduzuShop6.url,
    width: 1312,
    height: 1199,
    scene: "belgelerimizin asılı olduğu karşılama bankosu, müşteri temsilcimiz ve servise çıkan ustamız",
    caption: (area) =>
      `İş yeri açma ruhsatımız ve mesleki yeterlilik belgelerimiz duvarda; ${area} için de aynı belgeli ekip geliyor.`,
  },
  {
    url: beylikduzuShop7.url,
    width: 1370,
    height: 1148,
    scene: "plaza koridorundaki yönlendirme tabelamız ve ofise giren çantalı ustamız",
    caption: (area) =>
      `Bizi 2. katta yüz yüze bulabilirsiniz; ${area} randevuları için buraya uğramanıza da gerek yok, biz geliyoruz.`,
  },
  {
    url: beylikduzuShop8.url,
    width: 1448,
    height: 1086,
    scene: "kesit kesit kablo rafları önünde malzeme hazırlayan iki ustamız",
    caption: (area) =>
      `3x1.5 ve 3x2.5 kablodan sigortaya kadar malzeme stokta; ${area} arızalarında malzeme beklemiyoruz.`,
  },
];

/** Silivri Hızlı Elektrikçi 7/24 iş yerimizin gerçek fotoğrafları. */
const silivriHeroPhoto: ShopHeroPhoto = {
  url: silivriShop1.url,
  width: 1312,
  height: 1199,
  scene:
    "Marmara Plaza No:50/22'deki ışıklı tabelamız ve açık kapısıyla Silivri iş yerimizin ön cephesi",
};

const silivriPhotos: ShopPhoto[] = [
  {
    url: silivriShop1.url,
    width: 1312,
    height: 1199,
    scene: "ışıklı tabelamız, iletişim panomuz ve içeride görünen karşılama bankomuz",
    caption: (area) =>
      `${area} ekiplerimizin hareket noktası: Piri Mehmet Paşa Mahallesi Marmara Plaza No:50/22'deki gerçek iş yerimiz.`,
  },
  {
    url: silivriShop2.url,
    width: 1312,
    height: 1199,
    scene: "plaza girişindeki tabelamız ve alet çantasıyla ofise giren üniformalı ustamız",
    caption: (area) =>
      `${area} çağrısı geldiğinde ustamız çantasını burada hazırlayıp doğrudan adrese hareket ediyor.`,
  },
  {
    url: silivriShop3.url,
    width: 1370,
    height: 1148,
    scene: "telefonla çağrı alan müşteri temsilcimiz ve raflar önünde iş kaydı tutan ustamız",
    caption: (area) =>
      `${area} çağrıları telefonla anında kayda alınıyor; hangi ustanın ne zaman geleceğini konuşurken söylüyoruz.`,
  },
  {
    url: silivriShop4.url,
    width: 1312,
    height: 1199,
    scene: "müşterisine otomatik sigorta ve kaçak akım rölesi seçeneklerini anlatan teknik danışmanımız",
    caption: (area) =>
      `${area} işlerinde hangi sigortanın neden seçildiğini, işe başlamadan önce masada tek tek anlatıyoruz.`,
  },
  {
    url: silivriShop5.url,
    width: 1312,
    height: 1199,
    scene: "atölyemizde test panosu üzerinde ölçüm cihazıyla kontrol yapan ustamız",
    caption: (area) =>
      `${area} montajlarında kullanılan panolar atölyemizde kurulup ölçülerek, test edilmiş halde sahaya çıkıyor.`,
  },
  {
    url: silivriShop6.url,
    width: 1370,
    height: 1148,
    scene: "otomatik sigorta, kaçak akım rölesi ve kablo raflarında malzeme hazırlayan iki ekip üyemiz",
    caption: (area) =>
      `Sigortadan kabloya kadar malzeme rafta hazır; ${area} arızalarında malzeme temini için zaman kaybetmiyoruz.`,
  },
  {
    url: silivriShop7.url,
    width: 1370,
    height: 1148,
    scene: "belgelerimizin asılı olduğu karşılama alanı, müşterimiz ve servise çıkan çantalı ustamız",
    caption: (area) =>
      `Ustalık ve yeterlilik belgelerimiz duvarda asılı; ${area} adresine de aynı belgeli ekip geliyor.`,
  },
  {
    url: silivriShop8.url,
    width: 1312,
    height: 1199,
    scene: "örnek sigorta panosu üzerinde etiketleme ve kontrol yapan ustamız",
    caption: (area) =>
      `${area} panolarında her hattı etiketliyoruz; arıza tekrarladığında hangi hat olduğu bir bakışta görülüyor.`,
  },
  {
    url: silivriShop9.url,
    width: 1370,
    height: 1148,
    scene: "günlük iş listesinin yazılı olduğu panonun önünde servis çantalarını hazırlayan iki ustamız",
    caption: (area) =>
      `Günlük iş listemiz panoda; ${area} için verilen randevu saatini gün içinde kaydırmadan tutuyoruz.`,
  },
  {
    url: silivriShop10.url,
    width: 1448,
    height: 1086,
    scene: "karşılama bankosu, çağrı masası ve anahtar-priz teşhir panosuyla iş yerimizin genel iç görünümü",
    caption: (area) =>
      `Priz, anahtar ve aydınlatma seçeneklerini yerinde görebilirsiniz; ${area} için seçim yapmadan önce uğrayabilirsiniz.`,
  },
];

const heroByDistrict: Record<string, ShopHeroPhoto> = {
  buyukcekmece: defaultHeroPhoto,
  avcilar: avcilarHeroPhoto,
  bahcesehir: bahcesehirHeroPhoto,
  esenyurt: esenyurtHeroPhoto,
  beylikduzu: beylikduzuHeroPhoto,
  silivri: silivriHeroPhoto,
};

const photosByDistrict: Record<string, ShopPhoto[]> = {
  buyukcekmece: defaultPhotos,
  avcilar: avcilarPhotos,
  bahcesehir: bahcesehirPhotos,
  esenyurt: esenyurtPhotos,
  beylikduzu: beylikduzuPhotos,
  silivri: silivriPhotos,
};

export const getShopHeroPhoto = (districtSlug: string): ShopHeroPhoto =>
  heroByDistrict[districtSlug] ?? defaultHeroPhoto;

export const getShopPhotos = (districtSlug?: string): ShopPhoto[] =>
  (districtSlug && photosByDistrict[districtSlug]) || defaultPhotos;

/** Geriye dönük uyumluluk için varsayılan set */
export const SHOP_HERO_PHOTO = defaultHeroPhoto;
export const SHOP_PHOTOS = defaultPhotos;
